// material-ui

// ==============================|| OVERRIDES - DIALOG CONTENT ||============================== //

export default function DialogContent() {
    return {
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    maxHeight: "calc(100vh - 200px)",
                    overflowY: "auto",
                },
            },
        },
    }
}
